import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "send-button" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.generating)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          class: "stop-button",
          primary: "",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('stop')), ["stop"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              icon: "stop",
              width: "2rem",
              height: "2rem"
            })
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          class: "input-button",
          disabled: !$props.canPush,
          primary: "",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('push', $event)), ["stop"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              class: "send-icon",
              icon: "star-04",
              width: "2rem",
              height: "2rem"
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"]))
  ]))
}